// livestreamTelemetry.js
'use strict';
import { fromJS } from 'immutable';
import {
  SET_LIVESTREAM_TELEMETRY_DATA,
  REMOVE_LIVESTREAM_TELEMETRY_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

/*
Per-second player telemetry, kept out of the `liveStream` slice so the
frequent writes never touch cold UI data. Samples are cleared after each
freeze rate evaluation, so the series stays bounded.
{
  [streamId]: {
    [sessionId]: {
      [timestamp]: {
        [remoteUserId]: {
          freezeRate: Number,
          totalFreezeTime: Number,
        }
      }
    }
  }
}
*/
export const defaultState = fromJS({});

/**
 * Live stream telemetry.
 * @module reducer/livestreamTelemetry
 */
const livestreamTelemetry = (state = defaultState, action) => {
  switch (action.type) {
    case SET_LIVESTREAM_TELEMETRY_DATA:
      return _SET_LIVESTREAM_TELEMETRY_DATA(action.payload)(state);
    case REMOVE_LIVESTREAM_TELEMETRY_DATA:
      return _REMOVE_LIVESTREAM_TELEMETRY_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Set live stream telemetry data
 * @kind reducer/actionType
 * @name SET_LIVESTREAM_TELEMETRY_DATA
 * @param {array} {selectPath} - select path
 * @param {any} {data} - telemetry data
 * @return {Immutable.Map} New state
 */
const _SET_LIVESTREAM_TELEMETRY_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.setIn([...selectPath], fromJS(data));
  };

/**
 * Remove live stream telemetry data
 * @kind reducer/actionType
 * @name REMOVE_LIVESTREAM_TELEMETRY_DATA
 * @param {array} {selectPath} - select path
 * @return {Immutable.Map} New state
 */
const _REMOVE_LIVESTREAM_TELEMETRY_DATA =
  ({ selectPath }) =>
  state => {
    return state.deleteIn(selectPath);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default livestreamTelemetry;
